import React, { Suspense, useEffect, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import Header from './components/Header';
import Footer from './components/Footer';
import { Box } from '@mui/material';

// /crypto is legacy and isn't linked from the nav, but statically importing it pulled
// CryptoTracker + cryptoService + axios into the homepage bundle for every visitor.
const CryptoTracker = lazy(() => import('./pages/CryptoTracker'));

// Full-page navigation to a server-served path (e.g. the /fisk dashboard,
// which is a separate build mounted by nginx — not part of this SPA).
const HardRedirect = ({ to }: { to: string }) => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
};

const App: React.FC = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/crypto" element={<CryptoTracker />} />
            {/* Legacy path — the dashboard now lives at /fisk */}
            <Route path="/fiskekamera" element={<HardRedirect to="/fisk" />} />
            {/* Fallback if nginx hasn't served the fisk build yet */}
            <Route path="/fisk" element={<HardRedirect to="/fisk/" />} />
          </Routes>
        </Suspense>
      </Box>
      <Footer />
    </Box>
  );
};

export default App;
